export default [
  {
    title: '۳ تا ۷ سال',
    shortTitle: '۳-۷',
    value: 1,
  }, {
    title: '۸ تا ۹ سال',
    shortTitle: '۸-۹',
    value: 2,
  }, {
    title: '۱۰ تا ۱۲ سال',
    shortTitle: '۱۰-۱۲',
    value: 3,
  }, {
    title: '۱۳ تا ۱۵ سال',
    shortTitle: '۱۳-۱۵',
    value: 4,
  }, {
    title: '۱۶ تا ۱۸ سال',
    shortTitle: '۱۶-۱۸',
    value: 5,
  }, {
    title: '۱۹ سال به بالا',
    shortTitle: '۱۹-...',
    value: 7,
  },
]
